export const LOCALE_FETCH_LOCALISATIONS = 'locale.fetch-localisations';
export const LOCALE_SET_LOCALISATIONS = 'locale.set-localisations';
export const LOCALE_CLEAR_LOCALISATIONS = 'locale.clear-localisations';
export const LOCALE_SET_LOCALE = 'locale.set-locale';
export const LOCALE_SET_FALLBACK_LOCALE = 'locale.set-fallback-locale';
